import { AdaaHelper } from "../../../../../../../core/utils";
import { SharedFields } from "../../configs";
import { ScreenSectionConfigType } from "../../wf-difference.types";

const sectorConfig: ScreenSectionConfigType = {
  field: "sectorId",
  label: "national_projects.national_sector.title",
  view: "normal",
  visibleIf: (data: { sectorId: number }) => AdaaHelper.isDefined(data?.sectorId),
  format: (data: unknown) => AdaaHelper.getItemValueByToken(data, "sectorName"),
};

const pillarConfig: ScreenSectionConfigType = {
  field: "pillarId",
  label: "ekpi.piller",
  view: "normal",
  visibleIf: (data: { pillarId: number }) => AdaaHelper.isDefined(data?.pillarId),
  format: (data: unknown) => AdaaHelper.getItemValueByToken(data, "pillarName"),
};

const layoutConfig: ScreenSectionConfigType = {
  field: "layoutId",
  label: "government_scores.scopes.layout_type",
  view: "normal",
  visibleIf: (data: { pillarId: number }) => AdaaHelper.isDefined(data?.pillarId),
  format: (data: unknown) => AdaaHelper.getItemValueByToken(data, "layoutName"),
};

export const measurementScopeScreenConfig = [
  ...SharedFields.name,
  ...SharedFields.description,
  SharedFields.entityIdField,
  pillarConfig,
  sectorConfig,
  layoutConfig,
];
